import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { authStoreStateSelector } from '~/selectors';
import { People } from '~/services/Http';

export const useLoggedInEmployeeProfile = (): People.EmployeeProfileDto => {
  return useSelector((state: StoreState) => {
    return authStoreStateSelector(state).employeeProfile!;
  });
};
